import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSkip5SecondsForward12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSkip5SecondsForward12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.854 1.025a.5.5 0 0 0-.707.707L4.414 3H2.5A2.5 2.5 0 0 0 0 5.5v3A2.5 2.5 0 0 0 2.5 11H5a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 1 1 8.5v-3A1.5 1.5 0 0 1 2.5 4h1.914L3.147 5.268a.5.5 0 0 0 .707.707l2.121-2.121a.5.5 0 0 0 0-.708zM9.864 8c.664 0 1.132-.486 1.136-1.007.005-.558-.39-.998-.864-.998-.466 0-.804.106-1.018.205a1.6 1.6 0 0 0-.28.164l-.005.005A.5.5 0 0 1 8 5.996V3h2.954a.5.5 0 0 1 0 1H9v1.173c.3-.101.68-.178 1.136-.178 1.164 0 1.872 1.038 1.864 2.007C11.99 8.14 11.006 9 9.864 9c-.512 0-.933-.156-1.221-.308a2.7 2.7 0 0 1-.466-.31l-.01-.01-.003-.002-.001-.001v-.001l.337-.369-.338.368a.5.5 0 0 1 .673-.739z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSkip5SecondsForward12);
